export const MintagaBuildingReviewsButtonStatsGtmClick = {
  eventCategory: 'Building Review',
  eventAction: 'Click:mintaga',
  event: 'customEvent',
};
